import { createActionsHook } from 'src/lib/sweetState';

import { ResourceStore } from './ResourceStore';

export const useResourceActions = createActionsHook(ResourceStore);
